"use client";

import { atom } from "jotai";
import { PayrollEmployee } from "../entities/payroll-employee.entity";
import { Entry, Vendor, VendorType, ComplianceStatus } from "@/prisma-package/src";
import { Maybe } from "../types/utility.types";

export enum DrawerTypes {
  ENTRY_DETAILS = "entry-details",
  ENTRY_COMMENTS = "entry-comments",
  VENDOR_DETAILS = "vendor-details",
}

export enum DrawerStates {
  ACTIVE = "active",
  DISMISSED = "dismissed",
}

export type Drawer = {
  state: DrawerStates;
  type?: DrawerTypes;
  data?:
    | EntryDetailsDrawerData
    | VendorDetailsDrawerData
    | EntryCommentsDrawerData;
};

export type EntryDetailsDrawerData = {
  projectId: string;
  ledgerUploadId: string;
  payrollEmployees: (PayrollEmployee & { id: string })[];
  vendors: Vendor[];
  fullEntryData: Entry;
  orgId?: string;
};

export type EntryCommentsDrawerData = {
  entry: Entry;
  projectId: string;
  orgId?: string;
};

export type VendorDetailsDrawerData = {
  id: string;
  name: string;
  type?: Maybe<VendorType>;
  ein?: Maybe<string>;
  addressLineOne?: Maybe<string>;
  addressLineTwo?: Maybe<string>;
  city?: Maybe<string>;
  state?: Maybe<string>;
  zipCode?: Maybe<string>;
  phone?: Maybe<string>;
  email?: Maybe<string>;
  website?: Maybe<string>;
  salesTaxId?: Maybe<string>;
  businessLicenseUrl?: Maybe<string>;
  w9Url?: Maybe<string>;
  complianceStatus?: Maybe<ComplianceStatus>;
};

export const drawerAtom = atom<Drawer>({
  state: DrawerStates.DISMISSED,
});
